module.exports = __webpack_public_path__ + "static/media/uploadSucceed.8f156d7d.png";